<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="warehouse" />

    <WarehouseList
      :warehouses="filteredWarehouses"
      :search-query="searchQuery"
      :pagination-config="paginationConfig"
      @update:search-query="searchQuery = $event"
      @create="openCreateModal"
      @edit="openEditModal"
      @delete="deleteWarehouse"
    />

    <div class="flex-grow-1"></div>
    <MainFooter />

    <CreateWarehouseModal
      :open="showModal"
      :is-edit="!!selectedWarehouse"
      :form="form"
      :errors="errors"
      :loading="loading"
      @close="closeModal"
      @save="saveWarehouse"
      @generate-code="generateWarehouseCode"
      @update-field="updateField"
    />
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";

import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import CreateWarehouseModal from "../../components/Settings/Warehouse/CreateWarehouseModal.vue";
import WarehouseList from "../../components/Settings/Warehouse/WarehouseList.vue";
import { useWarehouse } from "../../composables/useWarehouse";

const {
  searchQuery,
  filteredWarehouses,
  showModal,
  selectedWarehouse,
  form,
  errors,
  loading,
  paginationConfig,
  fetchWarehouses,
  openCreateModal,
  openEditModal,
  closeModal,
  saveWarehouse,
  updateField,
  generateWarehouseCode,
  deleteWarehouse,
} = useWarehouse();

onMounted(fetchWarehouses);
</script>
